import { HStack, VStack } from '@chakra-ui/react'
import { Button } from 'uikit'
import { Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import { HeadingItem, ItemIcon, ItemText } from 'uikit/Snippets'
import {
  Container,
  FilterHeader,
  FilterStack,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { getAccess } from 'features/Private'
import { ROLES } from 'shared/constants/user'
import { useRef } from 'react'
import { IoDocument } from 'react-icons/io5'
import { useStore } from '@tanstack/react-store'
import { authStore } from 'shared/store/auth'
import { useHistory } from 'react-router-dom'
import { getDateTimeReadFormat } from 'shared/utils/dateFormatting'
import { faqCategoryTitle, faqLang } from '../Faq.constants'
import { ListFilter } from './ListFilter'
import { useFetchFaqList } from './services/useFetchFaqList'
import { useExportFaq } from './services/useExportFaq'
import { useImportFaq } from './services/useImportFaq'

export const List = () => {
  const history = useHistory()
  const { list, hasMore, fetchNextPage, isLoading, fetch } = useFetchFaqList()
  const { refetch: downloadFaq, isLoading: isDownloading } = useExportFaq()
  const { mutate: uploadFaq, isLoading: isUploading } = useImportFaq()

  const filtersRef = useRef()
  const { user } = useStore(authStore)
  const isAdmin = getAccess(user.roles, [ROLES.admin])

  const onChangeFilters = (state) => {
    filtersRef.current = state
    const { search } = state

    fetch({ search })
  }

  return (
    <Container>
      <SnippetsContainer indentTop={122}>
        <SnippetsContainerMain>
          <Snippets columns="42px minmax(250px, 1fr) minmax(250px, 1fr) minmax(120px, 1fr) minmax(200px, 1fr) minmax(150px, 1fr)">
            <SnippetsHeading position="sticky" top="0" zIndex={3}>
              <HeadingItem />
              <HeadingItem>Вопрос</HeadingItem>
              <HeadingItem>Ответ</HeadingItem>
              <HeadingItem>Порядковый номер</HeadingItem>
              <HeadingItem>Категория</HeadingItem>
              <HeadingItem>Создан </HeadingItem>
            </SnippetsHeading>
            <SnippetsList
              data={list}
              isLoading={isLoading}
              hasMore={hasMore}
              onNext={() => fetchNextPage()}
            >
              {(item) => {
                const hasQuestion = item?.question.length !== 0
                const hasAnswer = item?.answer.length !== 0

                return (
                  <SnippetsItem to={`/services/faq/show/${item.id}`}>
                    <ItemIcon IconComponent={IoDocument} />
                    <ItemText lineClamp={hasQuestion ? 3 : undefined}>
                      {hasQuestion
                        ? item.question.find((item) => item.language === faqLang.RU).text
                        : undefined}
                    </ItemText>
                    <ItemText lineClamp={hasAnswer ? 3 : undefined}>
                      {hasAnswer
                        ? item.answer.find((item) => item.language === faqLang.RU).text
                        : undefined}
                    </ItemText>
                    <ItemText>{item?.order}</ItemText>
                    <ItemText>{item?.category && faqCategoryTitle[item?.category]}</ItemText>
                    <ItemText>{getDateTimeReadFormat(item?.created)}</ItemText>
                  </SnippetsItem>
                )
              }}
            </SnippetsList>
          </Snippets>
        </SnippetsContainerMain>
        <SnippetsContainerRightAside>
          <FilterHeader>
            <VStack w="full">
              <Button
                width="100%"
                onClick={() => history.push(`/services/faq/new`)}
                colorPalette="orange"
                disabled={!isAdmin}
              >
                Добавить
              </Button>
              <HStack w="full">
                <Button
                  flexGrow={1}
                  onClick={() => uploadFaq()}
                  disabled={!isAdmin}
                  variant="outline"
                  loading={isUploading}
                >
                  Импорт
                </Button>
                <Button
                  flexGrow={1}
                  onClick={() => downloadFaq()}
                  disabled={!isAdmin}
                  loading={isDownloading}
                >
                  Экспорт
                </Button>
              </HStack>
            </VStack>
          </FilterHeader>
          <FilterStack>
            <ListFilter onChange={onChangeFilters} />
          </FilterStack>
        </SnippetsContainerRightAside>
      </SnippetsContainer>
    </Container>
  )
}
